/* eslint-disable import/prefer-default-export */
import AgGrid from './components/AgGrid.react';

export {AgGrid};
